import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfHideTranscriptIconProps extends SvgIconProps {}
/**
 * component used to display show origin icon in interaction space header
 * @param props - CcfShowTranscriptIconProps
 * @example - <CcfShowTranscriptIcon />
 * @returns SVG of hide transcript icon in interaction space header
 */
export function CcfHideTranscriptIcon(props: CcfHideTranscriptIconProps) {
  return (
    <SvgIcon
      {...props}
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0C4.5 0 0 4.86 0 6.48C0 7.83 4.14 12.6 9 12.6C13.86 12.6 18 7.47 18 6.48C18 5.4 13.68 0 9 0V0ZM9 11.07C5.31 11.07 2.07 7.56 1.53 6.48C1.98 5.22 5.49 1.53 9 1.53C12.42 1.53 15.66 5.13 16.38 6.39C15.66 7.65 12.51 11.07 9 11.07V11.07ZM8.91 2.79C7.11 2.79 5.67 4.32 5.67 6.12C5.67 7.92 7.11 9.45 8.91 9.45C10.71 9.45 12.15 7.92 12.15 6.12C12.15 4.32 10.62 2.79 8.91 2.79V2.79ZM8.91 8.1C7.83 8.1 7.02 7.2 7.02 6.12C7.02 5.04 7.92 4.14 8.91 4.14C9.99 4.14 10.8 5.04 10.8 6.12C10.8 7.2 9.9 8.1 8.91 8.1ZM8.91 5.04C8.28 5.04 7.83 5.58 7.83 6.12C7.83 6.75 8.28 7.2 8.91 7.2C9.54 7.2 9.99 6.66 9.99 6.12C9.99 5.49 9.45 5.04 8.91 5.04V5.04Z"
        fill="#333333"
      />
    </SvgIcon>
  );
}

export default CcfHideTranscriptIcon;
